import { useFlag } from '@unleash/proxy-client-react';
import { useMemo } from 'react';

import {
  LeftMenuTabTypes,
  TabSelectorButtonMapper,
} from '../components/_organisms/DesignerTabs/DesignerTabUtils';
export type TabSelector = {
  tabTitle: LeftMenuTabTypes;
  icon: JSX.Element;
  displayTitle: string;
};
const useTabsSelector = (): {
  newSlideSelector: TabSelector[];
  editorSelector: TabSelector[];
  aiEditorSelector: TabSelector[];
} => {
  const useAITemplates = useFlag('AI_TEMPLATES');
  const newSlideSelector = useMemo(() => {
    return TabSelectorButtonMapper.filter(r => {
      return (
        r.tabTitle === 'templates' ||
        r.tabTitle === 'generators' ||
        r.tabTitle === 'uploads'
      );
    });
  }, []);
  const editorSelector = useMemo(() => {
    return TabSelectorButtonMapper.filter(r => {
      return (
        r.tabTitle !== 'templates' &&
        r.tabTitle !== 'generators' &&
        r.tabTitle !== 'prompts' &&
        r.tabTitle !== 'testCases' &&
        r.tabTitle !== 'uploads'
      );
    });
  }, []);

  const aiEditorSelector = useMemo(() => {
    return TabSelectorButtonMapper.filter(r => {
      if (!useAITemplates) return false;
      return r.tabTitle === 'prompts' || r.tabTitle === 'testCases';
    });
  }, [useAITemplates]);
  return { newSlideSelector, editorSelector, aiEditorSelector };
};

export default useTabsSelector;
